import { layout } from 'thewest/App.routing'
import { ContentDataTypes } from 'common/data/loader-definitions'

export const subscriberExclusive = (isRegional = false) => {
    const promoDDA: ContentDataTypes = isRegional
        ? {
              type: 'promotional',
              metadataKey: 'regional-subscriber-exclusive-card',
              pageSize: 1,
          }
        : {
              type: 'curation',
              name: 'promotional-cards',
              offset: 0,
              pageSize: 1,
          }
    return layout.nestedComposition({
        type: 'janus',
        props: {
            layoutRatio: '1:3',
            stretchColumns: true,
            verticalSpacing: 'xl',
        },
        contentAreas: {
            left: [
                layout.component({
                    type: 'section-header',
                    props: {
                        heading: 'Promotional',
                        hasMargin: true,
                        invisibleHeaderBreakpoint: 'md',
                    },
                }),
                layout.component({
                    type: 'promotional-card',
                    props: {
                        cardOrientation: {
                            defaultLayout: 'landscape',
                            alternativeLayoutOptions: {
                                breakpoint: 'md',
                                layout: 'portrait',
                            },
                        },
                        fixedRatio: '4:3',
                        hasBackground: true,
                        hasPadding: true,
                        mediaMode: 'edgeToEdge',
                        fontScale: 0.88,
                        showCTA: true,
                        verticalSpacing: 'md',
                        dataDefinitionArgs: promoDDA,
                    },
                }),
            ],
            right: [
                layout.component({
                    type: 'lima',
                    props: {
                        fixedRatios: ['16:9'],
                        intermediateColumns: 3,
                        finalColumns: 3,
                        hideByline: false,
                        hasBackground: true,
                        cardOrientation: { type: 'Landscape-Portrait' },
                        sectionHeader: {
                            heading: 'Subscriber Exclusive',
                            headingUrl: '/features',
                            section: 'default',
                        },
                        dataDefinitionArgs: {
                            type: 'curation',
                            name: 'subscriber-exclusive',
                            offset: 0,
                            pageSize: 3,
                        },
                    },
                }),
            ],
        },
    })
}
